import React, {useEffect, useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Overview.scss";

import 'chartjs-adapter-moment';
import 'moment';
import DatePicker from "../../components/DatePicker";
import OverviewAPI from "../../api/OverviewAPI";
import ApprovalList from "../../components/Overview/ApprovalList";
import ChartTemplate from "../../components/Overview/ChartTemplate";
import AccountsSection from "../../components/Overview/AccountsSection";
import {useSelector} from "react-redux";
import BlurLoading from "../../components/BlurLoading";



function LegalOverviewTemplate({formattedDate}) {
    const {
        GetAccountBalance,
        GetSOAChartsData,
        CurBalDOL,
        CurBalLBP,
        StatBalDOL,
        StatBalLBP,
        chartLoading,
        accountLoading
    } = OverviewAPI();

    const [dateRange, setDateRange] = useState([
        new Date(),
        new Date(),
    ]);

    const {flag} = useSelector((state) => state.transferResponse);

    useEffect(() => {
        if (dateRange) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);

            GetAccountBalance(startDateString, endDateString);
            GetSOAChartsData(startDateString, endDateString);
        }

    }, [dateRange, flag]);


    const curBalDOL = (CurBalDOL !== null ? CurBalDOL : null);
    const curBalLBP = (CurBalLBP !== null ? CurBalLBP : null);
    const statBalDOL = (StatBalDOL !== undefined ? StatBalDOL : null);
    const statBalLBP = (StatBalLBP !== undefined ? StatBalLBP : null);

    return (
        <>
            <HeaderComponent title="Overview"/>
            <div className="OverviewPage">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-lg-10 col-md-12 col-sm-12 overViewTopSection">
                            <div className="MerchantName d-none d-md-block">{formattedDate}</div>
                            <div className="DatePicker">
                                <DatePicker
                                    value={dateRange}
                                    onChange={setDateRange}
                                />
                            </div>
                        </div>

                    </div>

                    <div className="row gx-5">
                        <div className="row gx-5">
                            <AccountsSection accountLoading={accountLoading} data={curBalDOL} EntityType="LEGALENTITY" currency={"$"}/>
                            <AccountsSection accountLoading={accountLoading} data={curBalLBP} EntityType="LEGALENTITY" currency={"LBP"}/>
                        </div>
                    </div>
                    <div className="row gx-5">
                        <div className="row gx-5">
                            <ChartTemplate
                                chartLoading={chartLoading}
                                statBalDOL={statBalDOL}
                                statBalLBP={statBalLBP}
                                title="STATEMENT OF ACCOUNT"
                                dateRange={dateRange}
                            />
                        </div>
                    </div>

                    {(sessionStorage.getItem("EntityRole") !== "VIEWER") ? (
                        <ApprovalList/>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <BlurLoading />
        </>
    );
}

export default LegalOverviewTemplate;